import { useV2ListPaymentTermsForAccountQuery } from "@generated";

export interface PaymentTermOption {
  label: string;
  value: string;
}

const useListPaymentTerms = () => {
  let customError: string | null = null;

  const { data, error, isLoading } = useV2ListPaymentTermsForAccountQuery({});

  let paymentTerms: PaymentTermOption[] = [];

  if (data?.data) {
    try {
      const mapped = data.data
        .filter((pt) => pt.id && pt.attributes?.name)
        .map((pt) => ({
          value: String(pt.id),
          label: pt.attributes.name,
          isDefault: !!(pt.attributes as any)?.default,
        }));
      mapped.sort((a, b) => Number(b.isDefault) - Number(a.isDefault));
      paymentTerms = mapped.map(({ value, label }) => ({ value, label }));
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    paymentTerms,
    paymentTermsLoading: isLoading,
    error: error ?? customError,
  };
};

export default useListPaymentTerms;
